module.exports = __webpack_public_path__ + "img/bus-partner-img11.6f9d55ac.png";